import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import MaskedInput from 'react-text-mask';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import validator from 'validator';

import phoneImage from '../assets/images/white-iphone1.png';
import { createListing } from '../services/listing/createListing';
import { updateListing } from '../services/listing/updateListing';
import { removeListing } from '../services/listing/removeListing';
import { confirm } from '../utils/modals';
// import ConfirmModal from './ConfirmModal';

// import usersHaveSecondaryEmails from './SecondaryAlertsUsers';

const usersHaveSecondaryEmails = [
  {
    email: 'pat@patwattam.com',
    alertCount: 6,
  },
  {
    email: 'leads@Exquisitesa.com',
    alertCount: 6,
  },
  {
    email: 'thomas.tonya@icloud.com',
    alertCount: 5,
  },
  {
    email: 'flevyoffers@gmail.com',
    alertCount: 3,
  },
  {
    email: 'brian@northcountybrokernetwork.com',
    alertCount: 3,
  },
  {
    email: 'kimdiop@kw.com',
    alertCount: 3,
  },
  {
    email: 'chasegriesbach44@gmail.com',
    alertCount: 2,
  },
  {
    email: 'barbara@visoncomcorp.com',
    alertCount: 2,
  },
  {
    email: 'richandsherillatkw@gmail.com',
    alertCount: 2,
  },
  {
    email: 'icanfindyouahome@hotmail.com',
    alertCount: 2,
  },
  {
    email: 'cotaman61@gmail.com',
    alertCount: 2,
  },
  {
    email: 'timcroman@yahoo.com',
    alertCount: 2,
  },
  {
    email: 'guamenian@yahoo.com',
    alertCount: 2,
  },
  {
    email: 'mike@austinsummitgroup.com',
    alertCount: 2,
  },
  {
    email: 'agents@smytherealestate.com',
    alertCount: 2,
  },
  {
    email: 'nadinesells4u@gmail.com',
    alertCount: 2,
  },
  {
    email: 'todd@copproperties.com',
    alertCount: 2,
  },
  {
    email: 'maryann@maryannsteam.com',
    alertCount: 2,
  },
];

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      keepCharPositions={true}
      placeholderChar={'\u2000'}
    />
  );
}

const styles = theme => ({
  root: {
    maxWidth: theme.spacing.unit * 150,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
  },
  formContainer: {
    marginTop: 50,
    marginBottom: 50,
  },
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    height: 640,
    overflow: 'auto',
    flexDirection: 'column',
    padding: 30,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 350,
  },
  menu: {
    width: 200,
  },
  phoneImage: {
    maxWidth: 250,
  },
  phoneContainer: {
    maxWidth: 250,
    height: 517,
    margin: 'auto',
    background: `url(${phoneImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '250px auto',
    backgroundPosition: 'center',
  },
  phoneScreen: {
    padding: '65px 18px 0 20px',
  },
  sms: {
    padding: 10,
    borderRadius: 6,
    clear: 'both',
    wordBreak: 'break-word',
  },
  keyword: {
    background: '#4caf50',
    color: 'white',
    float: 'right',
  },
  response: {
    background: '#e0e0e0',
    color: 'black',
    float: 'left',
  },
});

class NewListingWizard extends Component {
  state = {
    availableSmsKeywords: this.props.availableKeywords,
    selectedSmsKeyword: '',
    teamId: this.props.agent.teamId, // get from current auth user
    agentPhoneNumber: this.props.agent.phoneNumber, // get from current auth user
    localPhoneNumber: this.props.agent.localPhoneNumber, // get from current auth user
    agentEmail: this.props.agent.email,
    listing: {
      title: { value: '', isChecked: true, isValidationSuccess: true },
      line1: { value: '', isChecked: true, isValidationSuccess: true },
      line2: { value: '', isChecked: true, isValidationSuccess: true },
      unitApt: { value: '', isChecked: true, isValidationSuccess: true },
      city: { value: '', isChecked: true, isValidationSuccess: true },
      state: { value: '', isChecked: true, isValidationSuccess: true },
      zip: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      bedrooms: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      bathrooms: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      unitSize: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      propertySize: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      price: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      currency: 'USD',
      website: {
        value: '',
        isChecked: true,
        errorText: '',
        isValidationSuccess: true,
      },
      textAlertNotification: {
        value: '',
        isChecked: false,
        errorText: '',
        isValidationSuccess: true,
      },
      shortUrl: '',
      additionalInfo: { value: '', isChecked: true, isValidationSuccess: true },
      emailsToNotify: [],
    },
    status: 'active',
    smsResponse: '', // response to be sent to the lead
    isSaveDisable: false,
  };

  handleDelete = selectedSmsKeyword => async () => {
    confirm({
      title: `Are you sure you want to delete a keyword ${selectedSmsKeyword}?`,
      message: 'This will be moved to available keywords',
      okLabel: 'Yes',
      cancelLabel: 'No',
    })
      .then(async () => {
        this.setState({
          isSaveDisable: true,
        });
        await removeListing(this.state, selectedSmsKeyword);
        this.props.handleDeleteListing();
      })
      .catch(() => {});
  };

  handleSave = async () => {
    this.setState({
      isSaveDisable: true,
    });

    let newListing = {};
    try {
      if (this.state.isEditing && this.state.listingId) {
        newListing = await updateListing(this.state);
        this.props.handleUpdateListing(newListing.result);
      } else {
        newListing = await createListing(this.state);
        this.props.handleCreateListing(newListing.result);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  handleChangeSelects = name => event => {
    const listing = { ...this.state.listing };
    listing[name] = {
      ...listing[name],
      isChecked: event.target.checked,
    };
    // const smsResponse = buildSmsResponse(listing);
    // this.setState({
    //   listing,
    //   smsResponse,
    // });
    this.setState({ listing });
  };

  handleCancel = () => {
    this.props.handleCloseModal();
  };

  setValidateValue = (name, inputValue) => {
    const listing = { ...this.state.listing };
    listing[name] = {
      ...listing[name],
      value: inputValue,
      errorText: '',
      isValidationSuccess: true,
    };
    this.setState({
      listing,
    });
  };

  setInvalidateValue = (name, inputValue, errorText, index = 0) => {
    const listing = { ...this.state.listing };
    if (name === 'emailsToNotify') {
      const newListingItem = {
        value: inputValue,
        errorText,
        isValidationSuccess: false,
      };
      listing[name][index - 14] = {
        ...listing[name][index - 14],
        ...newListingItem,
      };
    } else {
      listing[name] = {
        ...listing[name],
        value: inputValue,
        errorText,
        isValidationSuccess: false,
      };
    }

    this.setState({
      listing,
    });
  };

  handleChange = (name, index) => event => {
    const inputValue = event.target.value;
    const listing = { ...this.state.listing };

    switch (name) {
      case 'zip':
        if (
          inputValue &&
          !validator.isInt(inputValue, { min: 10000, max: 99999 })
        ) {
          const errorText = 'Invalid zipcode';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'bedrooms':
        let re = /^[0-9][0-9]?$/;
        if (inputValue && !re.test(`${inputValue}`)) {
          const errorText = 'Must be number or Less than 100';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'bathrooms':
        re = /^\d+\.\d{0,2}$/;
        let re1 = /^[0-9][0-9]?$/;
        if (
          inputValue &&
          !re.test(`${inputValue}`) &&
          !re1.test(`${inputValue}`)
        ) {
          const errorText = 'Must be number';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'price':
        re = /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/;
        if (inputValue && !re.test(`${inputValue}`)) {
          const errorText = 'Must be price';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'unitSize':
        re = /^(\d*([.,](?=\d{3}))?\d+)+((?!\1)[.,]\d\d)?$/;
        if (inputValue && !re.test(`${inputValue}`)) {
          const errorText = 'Must be number';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'propertySize':
        re = /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/;
        if (
          inputValue &&
          !re.test(`${inputValue}`) &&
          !validator.isFloat(inputValue, { min: 0.0, max: 999999999.99 })
        ) {
          const errorText = 'Must be number';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'website':
        if (inputValue && !validator.isURL(inputValue)) {
          const errorText = 'Must be URL';
          this.setInvalidateValue(name, inputValue, errorText);
          return errorText;
        } else {
          this.setValidateValue(name, inputValue);
        }
        break;
      case 'emailsToNotify':
        if (inputValue) {
          let isValidateEmail = validator.isEmail(inputValue);
          // const secondaryEmails = inputValue
          //   .split(',')
          //   .map(item => item.trim());

          // let isValidateEmail = false;
          // secondaryEmails.forEach(item => {
          //   isValidateEmail = validator.isEmail(item);
          //   if (!isValidateEmail) return;
          // });

          if (!isValidateEmail) {
            const errorText = 'Must be Email';
            this.setInvalidateValue(name, inputValue, errorText, index);
            return errorText;
          } else {
            this.setValidateValue(name, inputValue);
          }
        }
        break;
      case 'textAlertNotification':
        if (inputValue) {
          const isValidatePhoneNumber = validator.isMobilePhone(inputValue);
          if (!isValidatePhoneNumber) {
            const errorText = 'Enter a valid 10 digit US cell phone number.';
            this.setInvalidateValue(name, inputValue, errorText, index);
            return errorText;
          } else {
            this.setValidateValue(name, inputValue);
          }
        }
        break;
      default:
        break;
    }

    if (name === 'emailsToNotify') {
      const newListingItem = {
        value: inputValue,
        errorText: '',
        isValidationSuccess: true,
      };
      listing[name][index - 14] = {
        ...listing[name][index - 14],
        ...newListingItem,
      };
    } else {
      listing[name] = {
        ...listing[name],
        value: inputValue,
        errorText: '',
        isValidationSuccess: true,
      };
    }

    const smsResponse = buildSmsResponse(listing);
    this.setState({
      listing,
      smsResponse,
      isValidationSuccess: true,
    });
  };

  componentDidMount() {
    if (this.props.isEditing && this.props.listingId) {
      // get the listing for the current logged in user
      // update the state
      const activeListing = this.props.listings.filter(l => {
        return l.id === this.props.listingId;
      });

      const listing = mapListingData(activeListing[0]);
      const smsResponse = buildSmsResponse(listing);

      this.setState({
        listing,
        agentName: `${this.props.agent.firstName} ${this.props.agent.lastName}`,
        agentId: activeListing[0].agentId,
        listingId: this.props.listingId,
        isEditing: this.props.isEditing,
        selectedSmsKeyword: activeListing[0].smsKeyword,
        smsResponse,
      });
    }
    this.setState({
      agentName: `${this.props.agent.firstName} ${this.props.agent.lastName}`,
      teamId: this.props.agent.teamId, // get from current auth user
      agentPhoneNumber: this.props.agent.phoneNumber, // get from current auth user
      localPhoneNumber: this.props.agent.localPhoneNumber,
      agentEmail: this.props.agent.email,
    });
  }

  handleChangeSelectKeyword = event => {
    this.setState({
      selectedSmsKeyword: event.target.value,
      disableSave: false,
    });
  };

  checkValidation = () => {
    const listingFields = this.getListingFormFields();
    const { listing } = this.state;
    let isValidationSuccess = true;
    listingFields
      .filter((f, index) => {
        if (index < 14 && listing[f.id].isValidationSuccess === undefined) {
          return false;
        }
        if (index > 13) {
          if (
            listing['emailsToNotify'].length > 0 &&
            listing['emailsToNotify'][index - 14].isValidationSuccess ===
              undefined
          ) {
            return false;
          }
        }
        return true;
      })
      .forEach((f, index) => {
        if (index < 14 && !listing[f.id].isValidationSuccess) {
          isValidationSuccess = false;
        }
        if (index > 13) {
          if (
            listing['emailsToNotify'].length > 0 &&
            !listing['emailsToNotify'][index - 14].isValidationSuccess
          ) {
            isValidationSuccess = false;
          }
        }
      });
    return isValidationSuccess;
  };

  disableSave = () => {
    const { listing, selectedSmsKeyword, isSaveDisable } = this.state;

    if (!this.checkValidation()) return false;

    if (isSaveDisable) return false;
    const listingStatus =
      listing.title.value.length > 0 && listing.line1.value.length > 0;
    return listingStatus && selectedSmsKeyword.length > 0;
  };

  handleAddEmailToNotification = () => {
    const { listing } = this.state;
    const newAddedEmailsToNotify = [
      {
        value: '',
        errorText: '',
        isValidationSuccess: true,
      },
    ];
    const newEmailsToNotify = [
      ...listing.emailsToNotify,
      ...newAddedEmailsToNotify,
    ];

    const newlisting = { ...listing, emailsToNotify: newEmailsToNotify };
    this.setState({ listing: newlisting });
  };

  getListingFormFields = (isAddable = false) => {
    const { listing } = this.state;
    const emailsToNotify = {
      id: 'emailsToNotify0',
      label: 'Send e-mail notifications to',
      helperText: 'In addition to me',
      errorText: '',
      isValidationSuccess: true,
    };
    let emailsToNotifyFields = [emailsToNotify];

    if (listing.title.value) {
      for (let i = 1; i < listing.emailsToNotify.length; i++) {
        emailsToNotify.id = `emailsToNotify${i}`;
        emailsToNotifyFields.push(emailsToNotify);
      }
    }

    const otherFields = [
      {
        id: 'title',
        label: 'Listing Title',
        helperText: 'Give an appropriate name to your listing.',
        required: true,
      },
      { id: 'line1', label: 'Address Line 1', required: true },
      { id: 'line2', label: 'Address Line 2' },
      { id: 'city', label: 'City' },
      { id: 'state', label: 'State' },
      {
        id: 'zip',
        label: 'Zip',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'bedrooms',
        label: 'Bedrooms',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'bathrooms',
        label: 'Bathrooms',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'unitSize',
        label: 'Unit Size (Square Feet)',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'propertySize',
        label: 'Property Size (Acres: 12,345.70)',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'price',
        label: 'Price',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'additionalInfo',
        label: 'Additional Info',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'website',
        label: 'Website',
        helperText:
          'Please provide a valid url in the format - https://abcd.com or https://www.abcd.com. A unique short url (e.g. https://abzz.io/abYknd) will be created, when you save the listing.',
        errorText: '',
        isValidationSuccess: true,
      },
      {
        id: 'textAlertNotification',
        label: 'Text Alert Notification',
        errorText: '',
        isValidationSuccess: true,
      },
    ];

    return [...otherFields, ...emailsToNotifyFields];
  };

  getSecondaryAlertCount = agentEmail => {
    for (let i = 0; i < usersHaveSecondaryEmails.length; i++) {
      if (usersHaveSecondaryEmails[i].email === agentEmail) {
        return usersHaveSecondaryEmails[i].alertCount;
      }
    }
    return 1;
  };

  render() {
    const { classes, isEditing } = this.props;
    const {
      selectedSmsKeyword,
      availableSmsKeywords,
      listing,
      agentEmail,
    } = this.state;
    const listingFields = this.getListingFormFields();

    const secondaryAlertCount = this.getSecondaryAlertCount(agentEmail);

    return (
      <div className={classes.root}>
        {isEditing ? <h2>Edit Listing</h2> : <h2>New Listing</h2>}
        <Divider />
        <Grid container spacing={24}>
          <Grid item xs={12} sm={8}>
            <form
              id="listing-form"
              className={classes.container}
              autoComplete="off"
              noValidate
            >
              <FormLabel className={classes.label}>
                {isEditing ? 'Update Listing' : 'Create a New Listing.'}
              </FormLabel>
              <FormHelperText className={classes.helperText}>
                Select as many fields you would like to send as text response to
                your leads.
              </FormHelperText>
              {isEditing ? (
                <h4>Listing Keyword: {selectedSmsKeyword}</h4>
              ) : (
                <div>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="select-a-keyword">
                      Select a keyword
                    </InputLabel>
                    <Select
                      value={selectedSmsKeyword}
                      onChange={this.handleChangeSelectKeyword}
                      inputProps={{
                        name: 'select a keyword',
                        id: 'select-keyword',
                      }}
                    >
                      {availableSmsKeywords.map(k => {
                        return (
                          <MenuItem value={k} key={k}>
                            {k}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText>You must select a keyword.</FormHelperText>
                  </FormControl>
                </div>
              )}
              {listingFields.map((f, index) => {
                return (
                  <div key={`${f.label}_${index}`}>
                    {index !== 13 && (
                      <TextField
                        id={f.title}
                        label={f.label}
                        value={
                          index < 14
                            ? listing[f.id].value
                            : listing['emailsToNotify'].length > 0
                              ? listing['emailsToNotify'][index - 14].value
                              : ''
                        }
                        required={f.required}
                        className={classes.textField}
                        onChange={this.handleChange(
                          index > 13 ? 'emailsToNotify' : f.id,
                          index
                        )}
                        helperText={
                          index < 14
                            ? listing[f.id].errorText
                            : listing['emailsToNotify'].length > 0
                              ? listing['emailsToNotify'][index - 14].errorText
                              : ''
                        }
                        margin="normal"
                        error={
                          index < 14
                            ? listing[f.id].errorText ? true : false
                            : listing['emailsToNotify'].length > 0
                              ? true
                              : false
                        }
                      />
                    )}

                    {index === 13 && (
                      <React.Fragment>
                        <TextField
                          id={f.title}
                          label={f.label}
                          placeholder="(xxx) xxx-xxxx"
                          value={listing[f.id].value}
                          required={f.required}
                          className={classes.textField}
                          onChange={this.handleChange(f.id, index)}
                          InputProps={{
                            inputComponent: TextMaskCustom,
                          }}
                          helperText={listing[f.id].errorText}
                          margin="normal"
                          error={listing[f.id].errorText ? true : false}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={listing[f.id].isChecked}
                              onChange={this.handleChangeSelects(f.id)}
                              // value={f.id}
                              color="primary"
                            />
                          }
                          label="Text Alert"
                        />
                      </React.Fragment>
                    )}
                    {secondaryAlertCount > 1 &&
                      listingFields.length - 14 < secondaryAlertCount &&
                      index === listingFields.length - 1 &&
                      listing['emailsToNotify'].length > 0 &&
                      listing['title'].value && (
                        <Button onClick={this.handleAddEmailToNotification}>
                          +
                        </Button>
                      )}
                  </div>
                );
              })}
            </form>
          </Grid>
          <Grid item xs={12} sm={4}>
            <h4>Text response that will be sent to your lead/s. </h4>
            <div className={classes.phoneContainer}>
              <div className={classes.phoneScreen}>
                <p className={`${classes.sms} ${classes.keyword}`}>
                  {this.state.selectedSmsKeyword || 100}
                </p>
                {this.state.smsResponse ? (
                  <p className={`${classes.sms} ${classes.response}`}>
                    {this.state.smsResponse}
                  </p>
                ) : null}
              </div>
            </div>
          </Grid>
        </Grid>
        <Divider />
        <div className={classes.btnContainer}>
          <div>
            <Button
              disabled={!this.disableSave()}
              variant="contained"
              color="secondary"
              onClick={this.handleDelete(selectedSmsKeyword)}
            >
              Delete
            </Button>
          </div>
          <div>
            <Button onClick={this.handleCancel}> Cancel </Button>
            <Button
              disabled={!this.disableSave()}
              variant="contained"
              color="primary"
              onClick={this.handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

function buildSmsResponse(listing) {
  const smsItems = [
    listing.title,
    listing.line1,
    listing.line2,
    listing.unitApt,
    listing.city,
    listing.state,
    listing.zip,
    {
      ...listing.bedrooms,
      value: listing.bedrooms.value ? `${listing.bedrooms.value}BR` : null,
    },
    {
      ...listing.bathrooms,
      value: listing.bathrooms.value ? `${listing.bathrooms.value}BA` : null,
    },
    {
      ...listing.unitSize,
      value: listing.unitSize.value ? `${listing.unitSize.value}SF` : null,
    },
    {
      ...listing.propertySize,
      value: listing.propertySize.value
        ? `${listing.propertySize.value}AC`
        : null,
    },
    {
      ...listing.price,
      value: listing.price.value ? `$${listing.price.value}` : null,
    },
    {
      ...listing.additionalInfo,
      value: listing.additionalInfo.value
        ? `${listing.additionalInfo.value}`
        : null,
    },
    // {
    //   ...listing.website,
    //   value: listing.website.value
    //     ? listing.shortUrl
    //       ? `More Info: abzz.io/${listing.shortUrl}`
    //       : `More Info: abzz.io/abYknd`
    //     : null,
    // },
    {
      ...listing.website,
      value: listing.website.value
        ? `More Info: ${listing.website.value}`
        : null,
    },
  ];
  let sms = '';
  smsItems.forEach(item => {
    if (item && item.value) {
      sms += `${item.value}, `;
    }
  });
  return sms;
}

function mapListingData(listing) {
  const a = listing.address;
  const d = listing.details;
  const checked2 = listing.smsResponse.split(',').map(s => s.trim());
  const checked1 = [
    listing.title,
    a.line1,
    a.line2,
    a.city,
    a.state,
    a.zip,
    d.bedrooms + 'BR',
    d.bathrooms + 'BA',
    d.propertySize + 'AC',
    d.unitSize + 'SF',
    '$' + d.price,
    // 'More Info: abzz.io' + listing.shortUrl,
    'More Info: ' + listing.website,
  ];

  for (var key in checked1) {
    var value = checked1[key];

    if (value) {
      var myArr = value.split(',').map(s => s.trim());

      for (var key1 in myArr) {
        var value1 = myArr[key1];
        if (!checked2.includes(value1)) {
          checked1[key] = '';
        }
      }
    } else {
      checked1[key] = '';
    }
  }

  const checked = checked1;

  const l = {
    title: {
      value: listing.title || '',
      isChecked: checked.includes(listing.title),
      isValidationSuccess: true,
    },
    line1: {
      value: a.line1 || '',
      isChecked: checked.includes(a.line1),
      isValidationSuccess: true,
    },
    line2: {
      value: a.line2 || '',
      isChecked: checked.includes(a.line2),
      isValidationSuccess: true,
    },
    city: {
      value: a.city || '',
      isChecked: checked.includes(a.city),
      isValidationSuccess: true,
    },
    state: {
      value: a.state || '',
      isChecked: checked.includes(a.state),
      isValidationSuccess: true,
    },
    zip: {
      value: a.zip || '',
      isChecked: checked.includes(a.zip),
      errorText: '',
      isValidationSuccess: true,
    },
    bedrooms: {
      value: d.bedrooms || '',
      isChecked: checked.includes(`${d.bedrooms}BR`),
      errorText: '',
      isValidationSuccess: true,
    },
    bathrooms: {
      value: d.bathrooms || '',
      isChecked: checked.includes(`${d.bathrooms}BA`),
      errorText: '',
      isValidationSuccess: true,
    },
    unitSize: {
      value: d.unitSize || '',
      isChecked: checked.includes(`${d.unitSize}SF`),
      errorText: '',
      isValidationSuccess: true,
    },
    propertySize: {
      value: d.propertySize || '',
      isChecked: checked.includes(`${d.propertySize}AC`),
      errorText: '',
      isValidationSuccess: true,
    },
    price: {
      value: d.price || '',
      isChecked: checked.includes(`$${d.price}`),
      errorText: '',
      isValidationSuccess: true,
    },
    website: {
      value: listing.website || '',
      // isChecked: checked.includes(`More Info: abzz.io/${listing.shortUrl}`),
      isChecked: checked.includes(`More Info: ${listing.website}`),
      errorText: '',
      isValidationSuccess: true,
    },
    shortUrl: listing.shortUrl || '',
    additionalInfo: {
      value: listing.additionalInfo || '',
      isChecked: checked.includes(listing.additionalInfo),
      isValidationSuccess: true,
    },
    textAlertNotification: {
      value: listing.agentPhoneNumber.slice(2),
      isChecked:
        'isTextAlertNotification' in listing
          ? listing.isTextAlertNotification
          : false,
      errorText: '',
      isValidationSuccess: true,
    },
    emailsToNotify: listing.emailsToNotify.map(item => {
      return {
        value: item,
        errorText: '',
        isValidationSuccess: true,
      };
    }),
  };
  return l;
}

export default withStyles(styles)(NewListingWizard);



// WEBPACK FOOTER //
// ./src/components/NewListingWizard.js